import { action, observable } from 'mobx';
import { HttpClient } from 'Mri.Web.Common';

export class AuditStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAuditLog(userId: string) {
        const auditLog = await this.httpClient.get<Mri.Audit.AuditLog<any>[]>(`/api/v1/audit-log/${userId}`);
        if (auditLog) this.auditLogsByUser.set(userId, auditLog);
    }

    @action
    public async loadAcceptedDocumentsTermsAndConditionsAsync(title: string) {
        const auditLog = await this.httpClient.get<Mri.Audit.AuditLog<Mri.Audit.AcceptedDocumentsTermsAndConditionLog>>(
            `/api/v1/audit-log/accepted-documents-terms-and-conditions?title=${title}`
        );
        if (auditLog) this.acceptedDocumentsTermsAndConditions = auditLog;
    }

    @action
    public async loadUserSessionLog() {
        const sessionLog = await this.httpClient.get<Mri.Audit.AuditLog<Mri.Audit.UserSessionLog>[]>(
            `/api/v1/audit-log/user-session-log`
        );

        if (sessionLog) this.userSessionLog = sessionLog;
    }

    @action
    public async acceptDocumentsTermsAndConditionsAsync(title: string) {
        const auditLog = await this.httpClient.post<
        Mri.Audit.AuditLog<Mri.Audit.AcceptedDocumentsTermsAndConditionLog>
        >(`/api/v1/audit-log/accepted-documents-terms-and-conditions?title=${title}`);
        if (auditLog) this.acceptedDocumentsTermsAndConditions = auditLog;
    }

    public async logDocumentDownload(fileName: string) {
        await this.httpClient.post<Mri.Audit.AuditLog<Mri.Audit.DownloadedDocumentLog>>(
            `/api/v1/audit-log/downloaded-document?fileName=${fileName}`
        );
    }

    public async logPageView(page: string, displaySerialNumber?: string | null) {
        await this.httpClient.post<Mri.Audit.AuditLog<Mri.Audit.DownloadedDocumentLog>>(
            `/api/v1/audit-log/viewed-page`,
            null,
            {
                params: {
                    page,
                    displaySerialNumber,
                },
            }
        );
    }

    @observable
    public acceptedDocumentsTermsAndConditions?: Mri.Audit.AuditLog<Mri.Audit.AcceptedDocumentsTermsAndConditionLog>;

    @observable
    public auditLogsByUser = new Map<string, Mri.Audit.AuditLog<any>[]>();

    @observable
    public userSessionLog?: Mri.Audit.AuditLog<Mri.Audit.UserSessionLog>[];

    private readonly httpClient: HttpClient;
}
